import { ITransformData } from '@src/common/types/empTypes';

export const validateTransformData = (transformData: ITransformData) => {
  // validate name and target_dimension
  if (!transformData.dimension_value || !transformData.target_dimension) {
    return {
      key: ['New Name', 'Save to Dimension'],
      result: 'is null',
      status: false,
      field: 'dimension_value',
    };
  }
  // validate source_dimension
  const status = transformData.transform_rule.every((orTransformData) => {
    return orTransformData.source_dimension;
  });

  if (!status) {
    return {
      key: ['Metadata Name'],
      result: 'is null',
      status,
      field: 'metaName',
    };
  }

  const hasInvalidateRule = transformData.transform_rule.some((orTransformData) => {
    return (
      orTransformData.rule.filter((andTransformItems) => {
        return andTransformItems.filter((orTransformItem) => {
          return orTransformItem.value.length;
        }).length;
      }).length === 0
    );
  });

  if (hasInvalidateRule) {
    return {
      key: ['Transform rule'],
      result: 'is empty',
      status: false,
      field: 'rule',
    };
  }

  // remove rule without value of transform_rule
  transformData.transform_rule.forEach((orTransformData) => {
    orTransformData.rule = orTransformData.rule.filter((andTransformItems) => {
      return andTransformItems.filter((orTransformItem) => {
        return orTransformItem.value.length;
      }).length;
    });
  });

  return { transformData: transformData, status: true, field: '' };
};
